import { appointmentsBaseUrl, deleteData } from "@Services/constServices";

export const deleteDeleteAppointment = async (id) => {
  const url = `${appointmentsBaseUrl}?ReserveId=${id}`;
  const successMessage = "Reserva eliminada correctamente";
  const errorMessage =
    "Hubo un problema al eliminar la reserva, intente nuevamente";
  return deleteData(url, successMessage, errorMessage);
};
